import React, {Component} from 'react'
import InitialMap from './InitialMap'
import WyszukiwarkaService from "../WyszukiwarkaService";

export default class MapaTrasy extends Component {


    constructor(props) {
        super(props);

        this.state = {
            markers: []
        };

        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleMarkerClose = this.handleMarkerClose.bind(this)
    }

    handleMarkerClick(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) {
                    marker.showInfo = true
                } else {
                    marker.showInfo = false
                }
                return marker;
            }),
        })
    }

    handleMarkerClose(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) marker.showInfo = false;
                return marker;
            }),
        })
    }


    componentDidMount() {
        WyszukiwarkaService.getPrzystankiMapa(this.props.idKu)
            .then(function (response) {
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].nazPr === this.props.nazPrOd || response.data[i].nazPr === this.props.nazPrDo) {
                        response.data[i].showInfo = true
                    }
                }
                // response.data[0].showInfo = true
                // response.data[response.data.length-1].showInfo = true
                this.setState({markers: response.data})
            }.bind(this)).catch(error => {
            if (error.response.status === 500) {
                alert("Błąd", "", 3000)
            }
        })
            .catch((e) => {
                console.log(e)
            })
    }

    render() {
        return (
            <div style={{height: '95%'}}>
                <InitialMap
                    containerElement={
                        <div style={{height: '100%'}}/>
                    }
                    mapElement={
                        <div style={{height: '100%'}}/>
                    }
                    markers={this.state.markers}
                    markerFirst={this.state.markers[0]}
                    markerLast={this.state.markers[this.state.markers.length - 1]}
                    nazPrOd={this.props.nazPrOd}
                    nazPrDo={this.props.nazPrDo}
                    onMarkerClick={this.handleMarkerClick}
                    onMarkerClose={this.handleMarkerClose}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/wyszukiwarka/wyszukiwarkaComponents/MapaTrasy.js